/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import {
  SidebarComponent,
} from 'src/infrastructure/gatsby/types/sidebar-component';
import {
  StrapiArticles,
} from 'src/infrastructure/gatsby/types/strapi-articles';
import Sidebar from '../sidebar';
import RecentArticles from '../recent-articles';
import SubscribeForm from '../subscribe-form';
import SocialMedia from '../social-media';
import DownloadMedia from '../download-media';

interface IProps {
  sidebarComponents?: SidebarComponent[];
  recentSidebarArticles: StrapiArticles;
}

const SidebarBuilder: FC<IProps> = ({
  sidebarComponents,
  recentSidebarArticles,
}) => {
  if (!sidebarComponents) {
    throw new Error('No sidebar components provided!');
  }

  return (
    <Sidebar>
      {sidebarComponents?.map(({ type, ...content }) => {
        let Component;
        switch (type) {
          case 'sidebar-plugins.recent-blog-posts':
          case 'sidebar-plugins.recent-news': {
            Component = RecentArticles as FC<SidebarComponent & StrapiArticles>;
            break;
          }
          case 'sidebar-plugins.subscribe-form': {
            Component = SubscribeForm as FC<SidebarComponent>;
            break;
          }
          case 'sidebar-plugins.social-media': {
            Component = SocialMedia as FC<SidebarComponent>;
            break;
          }
          case 'sidebar-plugins.download-media': {
            Component = DownloadMedia as FC<SidebarComponent>;
            break;
          }
          default:
            return null;
        }

        return (
          <Component
            key={`${ type }_${ content.id }`}
            {...recentSidebarArticles}
            {...content}
          />
        );
      })}
    </Sidebar>
  );
};

export default SidebarBuilder;
